import React, { Component } from "react"

export default class CancelSubscribe extends Component {
	render() {
		return <div>Cancel</div>
	}
}
